import { ComponentProps } from 'react'

import { Outlet } from 'react-router-dom'

import { ErrorBoundary } from '@cash-web/shared-feature-error'

export const JourneyGlobalLayout = ({
  fallbackComponent,
}: {
  fallbackComponent?: ComponentProps<typeof ErrorBoundary>['FallbackComponent']
}) => {
  return (
    <ErrorBoundary FallbackComponent={fallbackComponent}>
      <Outlet />
    </ErrorBoundary>
  )
}
